export const SEND_PARSING_ERRORS = 'ipfabric/diagnostics/SEND_PARSING_ERRORS';
export const INITIALIZE = 'ipfabric/diagnostics/INITIALIZE';
export const SEND_FINISHED = 'ipfabric/diagnostics/SEND_FINISHED';
export const SEND_DIAGNOSTICS = 'ipfabric/diagnostics/SEND_DIAGNOSTICS';
